import { useLingui } from '@lingui/react/macro';
import { Input } from '@repo/videa-components/src/index';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

interface LocationSearchFiltersProps {
  postalCode: string;
  onPostalCodeChange: (postalCode: string) => void;
  radius: string;
  onRadiusChange: (radius: string) => void;
  isSearching: boolean;
}

export const LocationSearchFilters = ({
  postalCode,
  onPostalCodeChange,
  radius,
  onRadiusChange,
  isSearching,
}: LocationSearchFiltersProps) => {
  const { t } = useLingui();

  const radiusOptions = [
    { value: '10', label: t`10 km` },
    { value: '25', label: t`25 km` },
    { value: '50', label: t`50 km` },
    { value: '100', label: t`100 km` },
  ];

  return (
    <div className="vai-w-[28%] vai-bg-blue-50 vai-rounded-lg vai-p-4 vai-space-y-4">
      <div className="vai-space-y-2">
        <label className="vai-text-sm vai-font-medium vai-text-gray-700">
          {t`Postal Code`}
        </label>
        <Input
          type="text"
          value={postalCode}
          onChange={(e) => onPostalCodeChange(e.target.value.toUpperCase())}
          placeholder={t`Enter postal code`}
          maxLength={7}
          className="vai-w-full"
        />
        {isSearching && postalCode.length >= 5 && (
          <p className="vai-text-xs vai-text-gray-500">{t`Searching...`}</p>
        )}
      </div>

      <div className="vai-space-y-2">
        <label className="vai-text-sm vai-font-medium vai-text-gray-700">
          {t`Radius`}
        </label>
        <Select value={radius} onValueChange={onRadiusChange}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent side="bottom" align="start">
            {radiusOptions.map((option) => (
              <SelectItem
                key={option.value}
                value={option.value}
                className="vai-cursor-pointer hover:vai-bg-gray-100 vai-transition-colors"
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
